module.exports = __webpack_public_path__ + "img/login-recomendations1-exotics.d34d6e70.jpg";